/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type AlertActionTypes = typeof AlertActionTypes[keyof typeof AlertActionTypes];


export const AlertActionTypes = {
  Dismiss: 'Dismiss',
  Resolve: 'Resolve',
  ResendTempoLink: 'ResendTempoLink',
  Archive: 'Archive',
  GoToInsurance: 'GoToInsurance',
  ScheduleFollowUpAndResolve: 'ScheduleFollowUpAndResolve',
  ShowPatientRTMTrends: 'ShowPatientRTMTrends',
  SendPCCConsentForms: 'SendPCCConsentForms',
  ManuallyOptInToCCM: 'ManuallyOptInToCCM',
  SetUpTelehealthMeeting: 'SetUpTelehealthMeeting',
  ResendPCCReminder: 'ResendPCCReminder',
  EnrollInPCC: 'EnrollInPCC',
} as const;
